module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-subjects__user text-dark"
  }, [_c('div', {
    staticClass: "request-subjects__user__header"
  }, [_c('h2', {
    staticClass: "pad-1"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "request-subjects__subsection"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.displaySumTeaching))])])]), _vm._v(" "), _c('tbody', [(_vm.userSubjectsTeaching.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Ingen undervisning ønsket")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userSubjectsTeaching), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', {
      staticClass: "td-delete"
    }, [(!_vm.loadingSubjects[subject.id]) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true
        }),
        expression: "{ arrow: true }"
      }],
      staticClass: "icon__bg-circle icon-bin",
      attrs: {
        "content": "Fjern ønske"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('removeSubject', subject.id)
        }
      }
    }) : _c('div', {
      staticClass: "do-spinner do-spinner-small"
    })]), _vm._v(" "), _c('td', {
      staticClass: "td-subjects"
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          onShow: function () { return subject.vRequestedBy.length > 0; }
        }),
        expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0\n        }"
      }],
      staticClass: "subjects_subject subjects_subject__simple",
      class: {
        'subjects_subject--has-user': subject.vRequestedBy.length > 0
      },
      style: ([{
        'border-left-color': subject.color
      }, {
        'background-color': subject.color
      }]),
      attrs: {
        "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
      }
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
      staticClass: "number"
    }, [_vm._v("\n          " + _vm._s(_vm.showLessonsPerWeek ? subject.vLessonsPerWeek : subject.vHours) + "\n        ")])])
  })], 2)])]), _vm._v(" "), (_vm.userSubjectsOther.length > 0 && _vm.showOtherTasks) ? _c('div', {
    staticClass: "request-subjects__subsection"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_vm._m(1), _vm._v(" "), _c('th', {
    staticClass: "number text--grey"
  }, [_vm._v(_vm._s(_vm.sumOfHoursOther))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userSubjectsOther), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', {
      staticClass: "td-delete"
    }, [(!_vm.loadingSubjects[subject.id]) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true
        }),
        expression: "{ arrow: true }"
      }],
      staticClass: "icon__bg-circle icon-bin",
      attrs: {
        "content": "Fjern ønske"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('removeSubject', subject.id)
        }
      }
    }) : _c('div', {
      staticClass: "do-spinner do-spinner-small"
    })]), _vm._v(" "), _c('td', {
      staticClass: "td-subjects"
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          onShow: function () { return subject.vRequestedBy.length > 0; }
        }),
        expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0\n        }"
      }],
      staticClass: "subjects_subject subjects_subject__simple",
      class: {
        'subjects_subject--has-user': subject.vRequestedBy.length > 0
      },
      style: ([{
        'border-left-color': subject.color
      }, {
        'background-color': subject.color
      }]),
      attrs: {
        "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
      }
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
      staticClass: "number"
    }, [_vm._v("\n          " + _vm._s(subject.vHours) + "\n        ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects) ? _c('div', {
    staticClass: "request-subjects__user__section"
  }, [_c('table', {
    staticClass: "d-table request-subjects__assigned"
  }, [_c('thead', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('tr', {
    on: {
      "click": function($event) {
        _vm.isAssignedTeachingOpen = !_vm.isAssignedTeachingOpen
      }
    }
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "request-subjects__toggle"
  }, [_c('span', {
    staticClass: "request-subjects__toggle__left"
  }, [_c('h4', [_vm._v("Tildelt undervisning")]), _vm._v(" "), _c('span', {
    class: _vm.isAssignedTeachingOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "number text--grey"
  }, [_vm._v(_vm._s(_vm.displayAssignedSumTeaching))])])]), _vm._v(" "), (_vm.isAssignedTeachingOpen) ? _c('tbody', [(_vm.assignedTeaching.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Ingen fag eller undervisningsopgaver tildelt")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedTeaching), function(subject) {
    return _c('tr', {
      key: subject.rowId || subject.id
    }, [_c('td', {
      staticClass: "td-subjects td-subjects--assigned"
    }, [_c('div', {
      staticClass: "subjects_subject subjects_subject__simple",
      style: ([{
        'border-left-color': subject.color
      }, {
        'background-color': subject.color
      }])
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_c('div', [_vm._v(_vm._s(subject.vKlass))])]), _vm._v(" "), _c('td', {
      staticClass: "number"
    }, [_vm._v("\n          " + _vm._s(_vm.displayHours(subject.vHours)) + "\n        ")])])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects && _vm.showOtherTasks && !_vm.showPoolInfo) ? _c('div', {
    staticClass: "request-subjects__user__section"
  }, [_c('table', {
    staticClass: "d-table request-subjects__assigned"
  }, [_c('thead', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('tr', {
    on: {
      "click": function($event) {
        _vm.isAssignedOtherOpen = !_vm.isAssignedOtherOpen
      }
    }
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "request-subjects__toggle"
  }, [_c('span', {
    staticClass: "request-subjects__toggle__left"
  }, [_c('h4', [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('span', {
    class: _vm.isAssignedOtherOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "number text--grey"
  }, [_vm._v(_vm._s(_vm.assignedSumOther))])])]), _vm._v(" "), (_vm.isAssignedOtherOpen) ? _c('tbody', [(_vm.assignedOther.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Ingen øvrige opgaver tildelt")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedOther), function(subject) {
    return _c('tr', {
      key: subject.rowId || subject.id
    }, [_c('td', {
      staticClass: "td-subjects td-subjects--assigned"
    }, [_c('div', {
      staticClass: "subjects_subject subjects_subject__simple",
      style: ([{
        'border-left-color': subject.color
      }, {
        'background-color': subject.color
      }])
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_c('div', [_vm._v(_vm._s(subject.vKlass))])]), _vm._v(" "), _c('td', {
      staticClass: "number"
    }, [_vm._v("\n          " + _vm._s(_vm.formatHours(subject.vHours)) + "\n        ")])])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects) ? _c('table', {
    staticClass: "d-table request-subjects__total"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": !_vm.showPoolInfo ? 3 : 2
    }
  }, [_c('h4', [_vm._v("Samlet")])]), _vm._v(" "), (_vm.showPoolInfo) ? _c('td', {
    staticClass: "number text--grey"
  }, [_vm._v(_vm._s(_vm.displayTotalTeachingCombined))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Ønsket undervisning")]), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.displaySumTeaching))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Tildelt undervisning")]), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.displayAssignedSumTeaching))])]), _vm._v(" "), (_vm.showOtherPoolInfo) ? [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Ønsket øvrige opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.sumOfHoursOther))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.assignedSumOther))])])] : _vm._e(), _vm._v(" "), (_vm.showPoolInfo) ? [_c('tr', {
    staticClass: "pool-summary"
  }, [_c('td', [_c('span', {
    staticClass: "pool-label"
  }, [_vm._v("UV-pulje")]), _vm._v(" "), _c('span', {
    staticClass: "pool-value"
  }, [_vm._v(_vm._s(_vm.displayPoolTeachingHours))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "pool-label"
  }, [_vm._v("Ønsket og tildelt")]), _vm._v(" "), _c('span', {
    staticClass: "pool-value"
  }, [_vm._v(_vm._s(_vm.displayTotalTeachingCombined))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "pool-label"
  }, [_vm._v("Rest")]), _vm._v(" "), _c('span', {
    staticClass: "pool-value",
    class: {
      'pool-value--negative': parseFloat(_vm.teachingDiff) < 0
    }
  }, [_vm._v(_vm._s(_vm.displayTeachingDiff))])])])] : _vm._e(), _vm._v(" "), (!_vm.showPoolInfo) ? [(_vm.showOtherTasks) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Ønsket øvrige opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.sumOfHoursOther))])]) : _vm._e(), _vm._v(" "), (_vm.showOtherTasks) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.assignedSumOther))])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "number text-dark"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalSumOfHours))])])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects && _vm.showOtherTasks && _vm.showPoolInfo) ? _c('div', {
    staticClass: "request-subjects__user__section"
  }, [_c('table', {
    staticClass: "d-table request-subjects__assigned marg-1-top"
  }, [_c('thead', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('tr', {
    on: {
      "click": function($event) {
        _vm.isAssignedOtherOpen = !_vm.isAssignedOtherOpen
      }
    }
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "request-subjects__toggle"
  }, [_c('span', {
    staticClass: "request-subjects__toggle__left"
  }, [_c('h4', [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('span', {
    class: _vm.isAssignedOtherOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "number text-dark"
  }, [_vm._v(_vm._s(_vm.assignedSumOther))])])]), _vm._v(" "), (_vm.isAssignedOtherOpen) ? _c('tbody', [(_vm.assignedOther.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Ingen øvrige opgaver tildelt")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedOther), function(subject) {
    return _c('tr', {
      key: subject.rowId || subject.id
    }, [_c('td', {
      staticClass: "td-subjects td-subjects--assigned"
    }, [_c('div', {
      staticClass: "subjects_subject subjects_subject__simple",
      style: ([{
        'border-left-color': subject.color
      }, {
        'background-color': subject.color
      }])
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_c('div', [_vm._v(_vm._s(subject.vKlass))])]), _vm._v(" "), _c('td', {
      staticClass: "number"
    }, [_vm._v("\n          " + _vm._s(_vm.formatHours(subject.vHours)) + "\n        ")])])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showOtherPoolInfo) ? _c('table', {
    staticClass: "d-table request-subjects__total"
  }, [_c('tbody', [_c('tr', {
    staticClass: "pool-summary"
  }, [_c('td', [_c('span', {
    staticClass: "pool-label"
  }, [_vm._v("Øvrig-pulje")]), _vm._v(" "), _c('span', {
    staticClass: "pool-value"
  }, [_vm._v(_vm._s(_vm.poolOtherHours))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "pool-label"
  }, [_vm._v("Ønsket og tildelt")]), _vm._v(" "), _c('span', {
    staticClass: "pool-value"
  }, [_vm._v(_vm._s(_vm.totalOtherCombined))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "pool-label"
  }, [_vm._v("Rest")]), _vm._v(" "), _c('span', {
    staticClass: "pool-value",
    class: {
      'pool-value--negative': parseFloat(_vm.otherDiff) < 0
    }
  }, [_vm._v(_vm._s(_vm.otherDiff))])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Dine ønsker – Undervisning")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Dine ønsker – Øvrige opgaver")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("I alt")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ce3ee74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/RequestSubjectsUser.vue
// module id = 1788
// module chunks = 1